import Axios from "axios";
import toast from "react-hot-toast";
import { ServiceUrl } from "../utils/serviceUrl";
import { jsonToQuery } from "../utils";
import callApi from "../utils/callApi";

export const listAll = async () => {
  return new Promise((resolve, reject) => {
    Axios.get(ServiceUrl.ADMIN_SETTINGS.LIST)
      .then(function ({ data }) {
        if (data.status != "1") {
          toast.error(data.message || "Error");
        }
        resolve(data.data);
      })
      .catch(function (error) {
        //resolve([]);
        return [];
      });
  });
};

export const listSettingsFields = async (encode = false) => {
  return new Promise((resolve, reject) => {
    let url = ServiceUrl.ADMISSION.SETTINGS;
    if (encode) url += "?sta=1";
    Axios.get(url)
      .then(function ({ data }) {
        resolve(data.data);
      })
      .catch(function (error) {
        //resolve([]);
        return [];
      });
  });
};

export const _ListSettings = async (searchData = false, callBack = false) => {
  let url = ServiceUrl.ADMISSION.SETTINGS;
  if (searchData) url += "?" + jsonToQuery(searchData);
  return callApi(url, "get", false, callBack);
};
